import { MapTo } from '@adobe/cq-react-editable-components';
import React, { Component } from 'react';
import SPAXFFooter from './SPAXFFooter';

class SPAXFFooterWrapper extends Component {
  props: any;

  render(): JSX.Element {
    return (
      <div>
        <SPAXFFooter />
      </div>
    );
  }
}

export default MapTo('workplace-spa/components/spaxffooter')(SPAXFFooterWrapper);
